export const getInvoiceExpenseAmountPattern = (allowNegative: boolean): string =>
    `^${allowNegative ? '-?' : ''}(\\d{0,6}([.,]\\d{0,2})?)?$`;
